module.exports = __webpack_public_path__ + "static/img/code.7d7eace8.png";